<template>
  <v-dialog 
    v-model="dialogVisible" 
    :max-width="$vuetify.display.smAndDown ? '95vw' : '600px'"
    persistent 
    class="base-dialog"
    scrollable
  >
    <v-card class="dialog-card">
      <v-card-title class="dialog-header">
        <span class="header_title">{{ config.title }}</span>
        <v-spacer></v-spacer>
        <IconProvider name="X" size="20" color="#5f666d" class="close-btn" @click="emitClose" />
      </v-card-title>

      <v-card-text class="dialog-body">
        <slot />
      </v-card-text>

      <v-card-actions v-if="config.label" class="dialog-footer">
        <v-spacer v-if="!$vuetify.display.xs"></v-spacer>

        <v-btn v-if="config.needCanacel" variant="outlined"  color="#003f2d" class="cancel-button" @click="emitClose">
          <div class="cancel-btn">Cancel</div>
        </v-btn>
        <v-btn v-if="!config.isSelectAssignment" class="send-button" color="#003f2d" @click="emitAction" :disabled="!isValidForSubmit">
          <IconProvider v-if="config.hasIcon" name="Send" class="send-icon" />
          <div class="submit-btn">{{ config.label }}</div>
        </v-btn>
      </v-card-actions>

      <!-- Empty footer for spacing when no buttons -->
      <div v-else class="empty-footer"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import IconProvider from '../commons/IconProvider.vue';

export default {
  name: 'BaseDialog',
  props: {
    visible: Boolean,
    config: {
      type: Object,
      default: () => ({})
    },
    isValidForSubmit: {
      type: Boolean,
      default: null
    }
  },
  components: {
    IconProvider
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.emitClose();
        }
      }
    },
    isAssignmentSelected() {
      return this.config.showClearButton;
    },
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    emitAction() {
      this.$emit('action');
    }
  },
}
</script>

<style scoped>
.cancel-btn {
  font-family: Calibre-R;
  font-size: clamp(11px, 2.5vw, 12px) !important;
  font-weight: 500 !important;
  text-transform: none !important;
  color: #003f2d;
}

.submit-btn {
  font-family: Calibre-R;
  font-size: clamp(11px, 2.5vw, 12px) !important;
  font-weight: 500 !important;
  text-transform: none !important;
  color: #fff;
}

.dialog-card {
  box-shadow: 0 4px 32px rgba(0,0,0,0.15) !important;
  margin: 16px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  padding: clamp(12px, 3vw, 16px) !important;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.header_title {
  font-family: Calibre-R-Medium;
  font-weight: 500;
  font-size: clamp(14px, 3vw, 16px);
  line-height: 1.5;
  letter-spacing: normal;
  vertical-align: middle;
  color: #1a1a1a;
}

.close-btn {
  cursor: pointer;
  background: none !important;
  color: gray !important;
  padding: 2px;
  margin: 0px;
  touch-action: manipulation;
}

.dialog-body {
  overflow-y: auto;
  padding: 0 clamp(12px, 3vw, 16px) clamp(12px, 3vw, 16px) clamp(12px, 3vw, 16px) !important;
  flex: 1;
  min-height: 0;
}

.dialog-footer {
  border-top: 1px solid #ddd;
  background-color: #fff;
  padding: clamp(12px, 3vw, 16px) !important;
  gap: clamp(6px, 1.5vw, 8px);
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.empty-footer {
  padding: clamp(16px, 4vw, 24px);
}

.cancel-button {
  text-transform: none !important;
  font-size: clamp(14px, 3vw, 16px) !important;
  font-weight: 400 !important;
  height: clamp(32px, 8vw, 36px);
  min-width: clamp(80px, 20vw, 103px);
  padding: 0 clamp(8px, 2vw, 12px) !important;
  touch-action: manipulation;
}

@media (max-width: 320px) {
  .close-btn {
    padding: 2px!important;
    margin:0px;
  }
  
  .v-dialog--fullscreen > .v-overlay__content > .v-card, 
  .v-dialog--fullscreen > .v-overlay__content > .v-sheet, 
  .v-dialog--fullscreen > .v-overlay__content > form > .v-card, 
  .v-dialog--fullscreen > .v-overlay__content > form > .v-sheet{
    min-height: 79%;
    min-width: 79%;
  }
}

/* Force dialog width with higher specificity */
.v-application .v-dialog > .v-overlay__content {
  width: calc(100% - 20px) !important;
  max-width: calc(100% - 20px) !important;
}

/* Force width for all Vuetify dialog content wrappers */
.v-application .v-overlay--active .v-overlay__content,
.v-application .v-dialog .v-overlay__content,
.v-application .v-card {
  width: auto !important;
}

@media (max-width: 320px) {
  .v-dialog > .v-overlay__content {
    max-height: calc(100% - 20px)!important;
    width: calc(100% - 20px)!important;
    max-width: calc(100% - 20px)!important;
    margin: 10px!important;
  }

  /* Force minimum dialog width on very small screens */
  .v-application .v-dialog > .v-overlay__content,
  .v-application .v-overlay--active .v-overlay__content,
  .v-application .base-dialog .v-overlay__content {
    width: calc(100vw - 10px) !important;
    max-width: calc(100vw - 10px) !important;
    min-width: 310px !important;
    margin: 5px !important;
    left: 5px !important;
    right: 5px !important;
  }
  
  .v-application .base-dialog .dialog-card,
  .v-application .base-dialog .v-card {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    margin: 0 !important;
  }
  
  .dialog-body {
    overflow-x: hidden !important;
    padding: 8px !important;
  }
  
  /* Ensure dialog fills available space */
  .base-dialog {
    width: 100% !important;
  }
}

.send-button {
  background-color: #003f2d !important;
  color: white !important;
  display: flex;
  align-items: center;
  text-transform: none !important;
  font-size: clamp(14px, 3vw, 16px) !important;
  font-weight: 400 !important;
  height: clamp(32px, 8vw, 36px);
  min-width: clamp(90px, 22vw, 111px);
  padding: 0 clamp(8px, 2vw, 12px) !important;
  touch-action: manipulation;
}

.send-icon {
  width: clamp(16px, 4vw, 18px);
  margin-right: clamp(6px, 1.5vw, 8px);
}

.send-button:hover {
  background-color: #015b41 !important;
}

/* Mobile optimizations */
@media (max-width: 480px) {
  .dialog-card {
        margin: -12px !important;
        max-height: 96vh !important;
        width: calc(100% - -26px) !important;
  }
  
  .dialog-footer {
    flex-direction: row;
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
  }
  
  .cancel-button {
    width: auto;
    min-width: 64px;
    justify-content: center;
  }
  .send-button {
    width: auto;
    min-width: 64px;
    justify-content: center;
  }
  
  .v-dialog--fullscreen > .v-overlay__content > .v-card, 
  .v-dialog--fullscreen > .v-overlay__content > .v-sheet, 
  .v-dialog--fullscreen > .v-overlay__content > form > .v-card, 
  .v-dialog--fullscreen > .v-overlay__content > form > .v-sheet{
    min-height: 94%;
    min-width: 94%;
  }
  
  /* Ensure dialog takes full width on mobile */
  .v-dialog > .v-overlay__content,
  .v-overlay--active .v-overlay__content,
  .base-dialog .v-overlay__content {
    width: calc(100% - 8px) !important;
    max-width: calc(100% - 8px) !important;
  }
  
  /* Optimize date picker for mobile dialogs */
  .dialog-body {
    overflow-x: hidden !important;
  }
}
@media screen and (max-width: 600px) {
  .v-dialog--fullscreen > .v-overlay__content > .v-card, 
  .v-dialog--fullscreen > .v-overlay__content > .v-sheet, 
  .v-dialog--fullscreen > .v-overlay__content > form > .v-card, 
  .v-dialog--fullscreen > .v-overlay__content > form > .v-sheet{
    min-height: 94%;
    min-width: 94%;
  }
  
  /* Ensure dialog width for date picker */
  .v-dialog > .v-overlay__content,
  .v-overlay--active .v-overlay__content,
  .base-dialog .v-overlay__content {
    width: calc(100% - 16px) !important;
    max-width: calc(100% - 16px) !important;
  }
}

/* Global date picker adjustments for dialogs */
.base-dialog .dialog-body :deep(.custom-date-picker) {
  max-width: calc(100vw - 40px) !important;
  width: auto !important;
}

@media (max-width: 320px) {
  .base-dialog .dialog-body :deep(.custom-date-picker) {
    max-width: calc(100vw - 20px) !important;
    left: 10px !important;
    right: 10px !important;
    width: auto !important;
  }
}

@media (max-width: 480px) {
  .base-dialog .dialog-body :deep(.custom-date-picker) {
    max-width: calc(100vw - 30px) !important;
    left: -5px !important;
    width: auto !important;
  }
}
</style>